
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M16.68 30.195a7.4 7.4 0 0 1-1.58-3.104L4.623 29.789c.323 1.434.839 2.84 1.559 4.189A16.7 16.7 0 0 0 8.53 37.32zM29.799 23.834a8.65 8.65 0 0 0-1.015-3.61l9.371-5.297a19.4 19.4 0 0 1 1.782 4.46c.38 1.451.586 2.907.63 4.345zM29.288 32.181a7.8 7.8 0 0 1-3.16 1.467l2.05 10.057a17.6 17.6 0 0 0 4.231-1.429 17.6 17.6 0 0 0 3.44-2.195zM21.455 14.073a8.45 8.45 0 0 0-3.259 1.855l-7.518-8.042a19 19 0 0 1 3.894-2.815 19 19 0 0 1 4.07-1.647z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#234652","d":"m9.416 35.186 8.689-7.02m12.34-9.573 8.036-7.023M5.632 26.5l10.533-1.941m15.824-2.384 10.82-2.145M12.2 8.59l7.02 8.689m9.617 12.248 6.978 8.128M20.884 4.806l2.173 10.713m2.254 15.844 2.044 10.62m13.964-26.538c4.424 9.515.296 20.815-9.219 25.239s-20.815.296-25.239-9.22-.296-20.815 9.22-25.239 20.815-.296 25.238 9.22Zm-9.975 4.637a8 8 0 1 1-14.508 6.745 8 8 0 0 1 14.509-6.745Z"}})])
          )
        }
      }
    